import { useQuery } from '@tanstack/react-query';
import { usersAPI } from '../lib/api.js';

export const useRoles = () => {
  return useQuery({
    queryKey: ['roles'],
    queryFn: () => usersAPI.getRoles(),
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: 1,
    retryOnMount: false, // Don't retry on mount if it fails
    refetchOnWindowFocus: false, // Don't refetch on window focus
  });
};
